// Exchange
export enum Exchange {
  BSE = 'BSE',
  MCX = 'MCX',
  NSE = 'NSE',
}

// Segment Types
export enum SegmentType {
  NSE_INDEX = 'NSE_INDEX',
  BSE_INDEX = 'BSE_INDEX',
  MCX_INDEX = 'MCX_INDEX',
  NSE_EQ = 'NSE_EQ',
  NSE_FO = 'NSE_FO',
  BSE_FO = 'BSE_FO',
  NCD_FO = 'NCD_FO',
  BSE_EQ = 'BSE_EQ',
  BCD_FO = 'BCD_FO',
  MCX_FO = 'MCX_FO',
  MCX_COM = 'MCX_COM',
  NSE_COM = 'NSE_COM',
}

export const DEFAULT_SEARCH_TABS: RenderTabs = [
  { title: 'ALL' },
  { title: 'CASH' },
  { title: 'FUTOPT' },
  { title: 'CURRENCY' },
  { title: 'COMMODITY' },
];

export const MIN_SEARCH_INPUT_LENGTH = 3;

export const DEFAULT_SEARCH_RESULTS: SearchResult = {
  INDEX: [],
  CASH: [],
  CURRENCY: [],
  FUTOPT: [],
  COMMODITY: [],
  ALL: [],
};

export const SEARCH_DEBOUNCE_TIMEOUT = 500;
